export const classroomStudentsFields = [
    {
        name: 'note',
        type: 'textarea',
        placeholder: 'Inserisci eventuali note',
        label: 'Note',
    }
]